const RAW_PLAYER_TOKEN_PATTERN = /^(player|temp|saved):[a-f\d]{12,}$/i;
const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

export const isRawPlayerToken = (value) => {
  const text = String(value || '').trim();
  return RAW_PLAYER_TOKEN_PATTERN.test(text) || OBJECT_ID_PATTERN.test(text);
};

const addAlias = (aliases, value) => {
  const text = String(value || '').trim();
  if (text) aliases.push(text);
};

export const getPlayerAliases = (player = {}) => {
  if (!player || typeof player !== 'object') return [];
  const aliases = [];
  addAlias(aliases, player.participantKey);
  addAlias(aliases, player.playerId);
  addAlias(aliases, player.tempPlayerId);
  addAlias(aliases, player.savedGaliPlayerId);
  addAlias(aliases, player.id);
  addAlias(aliases, player._id);
  if (player.playerId) addAlias(aliases, `player:${player.playerId}`);
  if (player.tempPlayerId) addAlias(aliases, `temp:${player.tempPlayerId}`);
  if (player.savedGaliPlayerId) addAlias(aliases, `saved:${player.savedGaliPlayerId}`);
  return [...new Set(aliases)];
};

export const getPlayerDisplayName = (player = {}) => {
  if (!player || typeof player !== 'object') return '';
  return String(
    player.displayName ||
    player.displayNameSnapshot ||
    player.name ||
    player.fullName ||
    player.personal?.fullName ||
    player.user?.name ||
    ''
  ).trim();
};

export const buildPlayerNameDirectory = (...sources) => {
  const map = new Map();
  sources.flat().filter(Boolean).forEach((player) => {
    const name = getPlayerDisplayName(player);
    if (!name || isRawPlayerToken(name)) return;
    getPlayerAliases(player).forEach((alias) => map.set(alias, name));
  });
  return map;
};

export const resolvePlayerDisplayName = (value, directory = new Map(), fallback = '') => {
  if (!value) return fallback;
  if (typeof value === 'object') {
    const directName = getPlayerDisplayName(value);
    if (directName && !isRawPlayerToken(directName)) return directName;
    for (const alias of getPlayerAliases(value)) {
      const resolved = directory.get(alias);
      if (resolved) return resolved;
    }
    return fallback;
  }
  const key = String(value).trim();
  const resolved = directory.get(key);
  if (resolved) return resolved;
  return isRawPlayerToken(key) ? fallback : key;
};
